import { axiosPrivate } from 'app/utils';

import helpers from './helpers';

export default {
  async getClinicOrders(params) {
    const resourceLink = helpers.getResourceLink('/clinic-orders', { ...params });

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getSingleClinicOrder({ orderId }) {
    const resourceLink = `/clinic-orders/${orderId}`;

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getClinicOrderReplacementProducts({ orderId }) {
    const resourceLink = `/clinic-orders/${orderId}/product-replacement`;

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getClinicOrderStats(params) {
    const resourceLink = helpers.getResourceLink('/clinic-orders/stats', { ...params });

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getClinicDeclinedReasons() {
    const requestUri = `/repeats/decline_reason?order_type=private_prescription`;
    const response = await axiosPrivate.get(requestUri);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async approveClinicOrder({ orderId, instructions, pin }) {
    const resourceLink = `/orders/${orderId}/prescription-request/approve`;
    const response = await axiosPrivate.post(resourceLink, { instructions, pin });

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async replacePrescriptionProduct({ orderId, productId, replacementProductId }) {
    const resourceLink = `/orders/${orderId}/products/${productId}/replace`;

    const response = await axiosPrivate.put(resourceLink, {
      type: 'private_prescription',
      product_id: replacementProductId,
    });
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getClinicPrescribers({ clinicId }) {
    const resourceLink = `/clinics/${clinicId}/prescribers`;

    const response = await axiosPrivate.get(resourceLink);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPharmaciesThatCanFulfil({ orderId }) {
    const resourceLink = `/clinic-orders/${orderId}/pharmacies`;
    const query = new URLSearchParams({ fulfilmentOptions: 'postal_delivery' });

    const response = await axiosPrivate.get(`${resourceLink}?${query}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
